import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, Text, withTheme, } from '@rneui/themed';
import { View, Slider } from '../../elements';
import { usePlaybackSpeed } from '../../..';
export const UnthemedPlaybackSpeed = ({ presetSpeeds = [0.7, 1.0, 1.2, 1.5, 2.0], minSpeed = 0.5, maxSpeed = 3.5, presetButtonProps, augmentButtonProps, titleStyle, }) => {
    const { playbackSpeed, setPlaybackSpeed } = usePlaybackSpeed();
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.title },
            React.createElement(Text, { style: [{ flex: 1 }, titleStyle] }, "Speed"),
            React.createElement(Text, { style: [{ flex: 1, textAlign: 'right' }, titleStyle] },
                playbackSpeed.toFixed(2),
                "x")),
        React.createElement(View, { style: styles.slider },
            React.createElement(Button, { style: { alignSelf: 'flex-start' }, onPress: () => {
                    const newSpeed = playbackSpeed - 0.1 < minSpeed ? minSpeed : playbackSpeed - 0.1;
                    setPlaybackSpeed(newSpeed);
                }, ...augmentButtonProps }, "-"),
            React.createElement(View, { style: { flexGrow: 1 } },
                React.createElement(Slider, { value: playbackSpeed, minimumValue: minSpeed, maximumValue: maxSpeed, onSlidingComplete: (val) => {
                        setPlaybackSpeed(Math.round(val * 100) / 100);
                    } })),
            React.createElement(Button, { style: { alignSelf: 'flex-end' }, onPress: () => {
                    const newSpeed = playbackSpeed + 0.1 < maxSpeed ? playbackSpeed + 0.1 : maxSpeed;
                    setPlaybackSpeed(newSpeed);
                }, ...augmentButtonProps }, "+")),
        React.createElement(View, { style: styles.buttons }, presetSpeeds.map((speed) => (React.createElement(Button, { key: speed, disabled: speed.toFixed(3) === playbackSpeed.toFixed(3), onPress: () => setPlaybackSpeed(speed), title: `${speed.toFixed(1)}`, ...presetButtonProps }))))));
};
const styles = StyleSheet.create({
    container: {
        maxWidth: '100%',
        width: '100%',
    },
    title: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        marginBottom: 20,
    },
    slider: {
        flexDirection: 'row',
        width: '100%',
        marginBottom: 20,
    },
    buttons: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
});
export const PlaybackSpeed = withTheme(UnthemedPlaybackSpeed, 'PlaybackSpeed');
//# sourceMappingURL=PlaybackSpeed.js.map